/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { ContactPaymentDataDto } from './contactPaymentDataDto.model';
import { MergedSubject } from './mergedSubject.model';


export interface ContractPaymentDataDto { 
    amount?: number;
    contactPaymentData?: ContactPaymentDataDto;
    contactPaymentDataId?: number;
    contractId?: number;
    contractSpecSym?: string;
    contractVarSym?: string;
    ownerId?: number;
    paymentSubject?: SubjectContactResponseDto;
    paymentSubjectId?: number;
    recipientContactPaymentDatas?: Array<ContactPaymentDataDto>;
    recipientPaymentSubject?: MergedSubject;
}

